export interface RonMonitorSummaryWire {
  scheduled: number;
  stuckClients: number;
  borrowerDelayed: number;
  notaryDelayed: number;
  runningOver: number;
  processingDocuments: number;
  completed: number;
  scheduledDenominator: number;
  cancelled: number;
  stuckThresholdMinutes: number;
}

export interface RonMonitorNotaryLaneWire {
  notaryAccountId: number;
  firstName: string | null;
  lastName: string | null;
  /** Always null today. See story 292892. */
  designation: string | null;
}

export interface RonMonitorClosingWire {
  packageId: number;
  notaryAccountId: number | null;
  loanIdentifier: string | null;
  partnerOrderIdentifier: string | null;
  scheduledDateTime: string | null;
  actualStartDateTime: string | null;
  statusCode: string;
  state: string;
  delayMinutes: number | null;
}

export interface RonMonitorBoardWire {
  generatedAtUtc: string;
  summary: RonMonitorSummaryWire;
  lanes: RonMonitorNotaryLaneWire[];
  closings: RonMonitorClosingWire[];
}

export interface RonMonitorAddressWire {
  streetAddress1: string | null;
  streetAddress2: string | null;
  city: string | null;
  stateCode: string | null;
  zipCode: string | null;
  zip4: string | null;
}

export interface RonMonitorOrderParticipantWire {
  participantId: number;
  firstName: string | null;
  lastName: string | null;
  role: string | null;
  phoneNumber: string | null;
  email: string | null;
  /** READY | VALID | CHECKEDIN. Null when the closing is not live: not reported, not "not joined". */
  statusCode: string | null;
  /** A PackageUserStep name or SigningRoom. Null when no step has started or the closing is not live. */
  currentStep: string | null;
  stepStatus: string | null;
  minutesInStep: number | null;
}

export interface RonMonitorOrderClosingWire {
  loanIdentifier: string | null;
  partnerOrderIdentifier: string | null;
  propertyAddress: RonMonitorAddressWire | null;
  scheduledDateTime: string | null;
  actualStartDateTime: string | null;
  actualCompleteDateTime: string | null;
  statusCode: string | null;
}

export interface RonMonitorOrderDetailWire {
  packageId: number;
  closing: RonMonitorOrderClosingWire | null;
  notary: RonMonitorOrderParticipantWire | null;
  clients: RonMonitorOrderParticipantWire[] | null;
}

/** Mirrors RonMonitorClosingStates.cs; change the two together. */
export const RON_MONITOR_CLOSING_STATES = {
  scheduled: "Scheduled",
  checkIn: "CheckIn",
  preSign: "PreSign",
  inSession: "InSession",
  processingDocuments: "ProcessingDocuments",
  completed: "Completed",
  cancelled: "Cancelled",
  stuck: "Stuck",
  borrowerDelayed: "BorrowerDelayed",
  notaryDelayed: "NotaryDelayed",
  runningOver: "RunningOver",
} as const;
